import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import styles from './praiseMail.module.scss';
import ContactChip from './ContactChip';
import { apiHolder as api, apis } from 'api';
import { useAppSelector } from '@web-common/state/createStore';
import { getIn18Text } from 'api';
const mailApi = api.api.requireLogicalApi(apis.mailApiImpl);
const PraiseDesc = () => {
    var _a, _b;
    const [allMedals, setMedals] = useState([]);
    useEffect(() => {
        mailApi.doGetPraiseMedals().then(setMedals);
    }, []);
    const praiseMail = useAppSelector(state => state.mailReducer.currentMail.praiseMail);
    const curMedal = allMedals.find(item => item.id === (praiseMail === null || praiseMail === void 0 ? void 0 : praiseMail.medalId));
    const [winners, setWinners] = useState([]);
    const receivers = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.receiver; });
    useEffect(() => {
        if (praiseMail && praiseMail.winners) {
            setWinners(praiseMail.winners);
        }
    }, [praiseMail]);
    return (React.createElement(React.Fragment, null, praiseMail ? (React.createElement("div", { className: classnames(styles.desc) },
        !!curMedal && (React.createElement("div", { className: classnames(styles.item) },
            React.createElement("img", { className: classnames(styles.medalImg), alt: curMedal === null || curMedal === void 0 ? void 0 : curMedal.name, src: curMedal === null || curMedal === void 0 ? void 0 : curMedal.imageUrl }),
            React.createElement("span", null, curMedal === null || curMedal === void 0 ? void 0 : curMedal.name))),
        !!winners.length && (React.createElement("div", { className: classnames([styles.item, styles.winners]) },
            React.createElement("span", null, getIn18Text('BIAOYANGDUIXIANG\uFF1A')),
            !!winners.length && React.createElement(ContactChip, { value: ((_b = (_a = winners[0]) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.accountName) || '', item: winners[0] }),
            React.createElement("span", { className: classnames(styles.winnersNum) }, winners.length > 1 ? `共${winners.length}人` : ''))),
        !!praiseMail.presentationWords && (React.createElement("div", { className: classnames(styles.item) },
            React.createElement("span", null, getIn18Text('BANJIANGCI\uFF1A')),
            React.createElement("span", { className: classnames(styles.textContent) }, praiseMail.presentationWords))),
        !!praiseMail.presenter && (React.createElement("div", { className: classnames(styles.item) },
            React.createElement("span", null, getIn18Text('BANJIANGREN\uFF1A')),
            React.createElement("span", { className: classnames(styles.textContent) }, praiseMail.presenter))))) : null));
};
export default PraiseDesc;
